export const MAX_DISPLAYED_FACET_VALUES = 6
export const INPUT_VARIANT = 'default'
export const RADIO = 'radio'
export const CHECKBOX = 'checkbox'
